import prettier from 'prettier/standalone';
import plugins from 'prettier/parser-html';
import { removeUnprintableChar } from '../utils';
export class HTMLFormatter {
    getFormatted(rawText, options = HTMLFormatter.defaultOptions) {
        let t = rawText;
        try {
            t = prettier.format(rawText, options);
        }
        catch (error) {
            // 
        }
        return t;
    }
    getRaw(formattedText) {
        return removeUnprintableChar(formattedText);
    }
}
HTMLFormatter.defaultOptions = { parser: 'html', plugins: [plugins] };
export default new HTMLFormatter();
